export function openChatSupport() {
  const node = document.getElementById("zsiq_float");
  if (node) {
    node.click();
  }
}

export function toggleElementVisibility(elementId, doShow) {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.toggle("lt-visible", doShow);
    element.classList.toggle("lt-hidden", !doShow);
  }
}

export function createDownloadLink({ fileName = "", url }) {
  const element = document.createElement("a");
  document.body.appendChild(element);
  element.style = "display: none";
  element.href = url;
  element.target = "_blank";
  element.download = fileName;
  element.click();
  document.body.removeChild(element);
}

export function highlightSideNavBuildItem(setInactive = false) {
  const archivesEl = document.getElementById(
    "automation_archive_menu_dropdown"
  );
  if (archivesEl) {
    archivesEl.classList.toggle("active", setInactive);
  }
  const buildsEl = document.getElementById("automation_builds_menu_dropdown");
  if (buildsEl) {
    buildsEl.classList.toggle("active", !setInactive);
  }
}

export const closeLeftCommonHeader = () => {
  // adding 'active' class to header tag to close it in case it is open
  const headerElem = document.getElementsByTagName("header");
  if (headerElem[0]) {
    const headerElemClassList = headerElem[0].classList;
    headerElemClassList.add("active");
  }

  // adding 'header__collapsed' class to body tag to set the content's left padding according to the closed side header
  const bodyElem = document.getElementsByTagName("body");
  if (bodyElem[0]) {
    const bodyElemClassList = bodyElem[0].classList;
    if (!bodyElemClassList.contains("header__collapsed")) {
      bodyElemClassList.add("header__collapsed");
    }
  }
};

export const getRemarkContainerHeight = promoBannerHeight => {
  const topRemarkWrapper = document.getElementsByClassName("commandLogRemark");
  let heightToSubtract = 280 + promoBannerHeight;
  if (topRemarkWrapper) {
    Object.keys(topRemarkWrapper).forEach(function(k) {
      if (topRemarkWrapper[k]) {
        heightToSubtract += topRemarkWrapper[k].offsetHeight;
      }
    });
  }
  return heightToSubtract;
};

export const copyTextToClipboard = textToCopy => {
  const textarea = document.createElement("textarea");
  textarea.value = textToCopy;

  // Make the textarea hidden
  textarea.style.position = "absolute";
  textarea.style.left = "-9999px";

  // Add the textarea to the document
  document.body.appendChild(textarea);

  // Select the text in the textarea
  textarea.select();

  // Copy the selected text to the clipboard
  document.execCommand("copy");

  // Remove the textarea from the document
  document.body.removeChild(textarea);
};